var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isNewInspection)?_c('check-detail-new',{attrs:{"data":_vm.data,"print-width":_vm.printWidth}}):_c('check-detail-legacy',{attrs:{"data":_vm.data,"print-width":_vm.printWidth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }